import React from 'react';
import { Sparklines, SparklinesLine, SparklinesSpots } from 'react-sparklines';
import { V3_COLORS } from './useApexTheme';

/**
 * Compact trend strip used inside the briefing block. Pure SVG via
 * react-sparklines — no Apex container overhead for what's basically
 * decorative context.
 */
export default function SparklineBlock({ title, series, labels }) {
    if (!Array.isArray(series) || series.length < 2) return null;
    const first = labels?.[0];
    const last = labels?.[labels.length - 1];
    return (
        <div className="chat-block">
            {title && <div className="chat-block-title">{title}</div>}
            <div className="sparkline-wrap">
                <Sparklines data={series} height={44} margin={4}>
                    <SparklinesLine
                        color={V3_COLORS.teal}
                        style={{ strokeWidth: 2, fill: V3_COLORS.teal, fillOpacity: 0.18 }}
                    />
                    <SparklinesSpots style={{ fill: V3_COLORS.teal }} />
                </Sparklines>
            </div>
            {(first || last) && (
                <div className="sparkline-meta">
                    <span>{first || ''}</span>
                    <span>{last || ''}</span>
                </div>
            )}
        </div>
    );
}
